import styled, { StyledProps } from 'styled-components'

type ContestActionButtonContainerProps = StyledProps<{
  color: string
  backgroundColor: string
}>

export const ContestActionButtonContainer = styled.button<ContestActionButtonContainerProps>`
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  height: 43px;
  min-width: 160px;

  padding: ${({ theme }) => `${theme.spacings[2.5]} ${theme.spacings[8]}`};

  font-family: BloggerSans, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 17px;

  color: ${({ color }) => color};
  background-color: ${({ backgroundColor }) => backgroundColor};

  border: ${({ color }) => `2px solid ${color}`};
  border-radius: 10px;
`
